/* Live Free — collection shelf (DESIGN-07b). Progressive enhancement only.
   Without this file: facets are links, sort is a form, pagination is links, the
   rail sits above the grid on small screens. With it: the shelf section is
   swapped through the Section Rendering API (URL kept honest with pushState),
   the rail becomes a bottom sheet on mobile, open/closed facet groups survive a
   swap, and Add posts to /cart/add.js and flips to "In your bag". */
(function () {
  'use strict';
  var shelf = document.querySelector('[data-lf-shelf]');
  if (!shelf) return;
  var mq = window.matchMedia('(max-width: 899px)');
  var inFlight = null;
  var openState = {};
  document.documentElement.classList.add('lf-shelf-js');

  function rememberFacets() {
    shelf.querySelectorAll('[data-lf-facet]').forEach(function (d) { openState[d.dataset.lfFacet] = d.open; });
  }
  function restoreFacets() {
    shelf.querySelectorAll('[data-lf-facet]').forEach(function (d) {
      if (openState[d.dataset.lfFacet] !== undefined) d.open = openState[d.dataset.lfFacet];
    });
  }

  function sectionUrl(url) {
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', shelf.dataset.sectionId);
    return u.toString();
  }

  function render(url, push) {
    var target = new URL(url, window.location.origin);
    var wasOpen = shelf.classList.contains('is-sheet-open');
    rememberFacets();
    shelf.setAttribute('aria-busy', 'true');
    return fetch(sectionUrl(target), { signal: inFlight.signal })
      .then(function (r) { if (!r.ok) throw new Error('section fetch failed'); return r.text(); })
      .then(function (html) {
        var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-lf-shelf]');
        if (!next) throw new Error('no section');
        shelf.innerHTML = next.innerHTML;
        shelf.removeAttribute('aria-busy');
        restoreFacets();
        if (wasOpen) openSheet(); else closeSheet();
        if (push) window.history.pushState({ lfShelf: true }, '', target.toString());
        if (!wasOpen && !mq.matches) shelf.scrollIntoView({ block: 'start', behavior: 'smooth' });
      });
  }

  function go(url, push) {
    if (!window.fetch || !window.history.pushState || !window.AbortController) { window.location.assign(url); return; }
    if (inFlight) inFlight.abort();
    inFlight = new AbortController();
    render(url, push).catch(function (err) {
      if (err.name === 'AbortError') return;
      window.location.assign(url);
    });
  }

  /* --- bottom sheet (mobile) --- */
  function openSheet() {
    shelf.classList.add('is-sheet-open');
    document.body.classList.add('lf-sheet-lock');
    var b = shelf.querySelector('[data-lf-sheet-open]'); if (b) b.setAttribute('aria-expanded', 'true');
    var c = shelf.querySelector('[data-lf-sheet-close]'); if (c) c.focus({ preventScroll: true });
  }
  function closeSheet() {
    shelf.classList.remove('is-sheet-open');
    document.body.classList.remove('lf-sheet-lock');
    var b = shelf.querySelector('[data-lf-sheet-open]'); if (b) b.setAttribute('aria-expanded', 'false');
  }

  shelf.addEventListener('click', function (e) {
    if (e.target.closest('[data-lf-sheet-open]')) { openSheet(); return; }
    if (e.target.closest('[data-lf-sheet-close]')) { closeSheet(); return; }
    if (e.target.matches('[data-lf-rail]') && shelf.classList.contains('is-sheet-open')) { closeSheet(); return; }
    var link = e.target.closest('a[data-lf-nav]');
    if (!link || e.metaKey || e.ctrlKey || e.shiftKey || link.target === '_blank') return;
    e.preventDefault();
    go(link.href, true);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && shelf.classList.contains('is-sheet-open')) closeSheet();
  });
  mq.addEventListener ? mq.addEventListener('change', function (m) { if (!m.matches) closeSheet(); }) : null;

  /* --- sort (lives in the head section) --- */
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-lf-sort] select');
    if (!select) return;
    var form = select.closest('form');
    go(form.action + '?' + new URLSearchParams(new FormData(form)).toString(), true);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-lf-sort]');
    if (!form) return;
    e.preventDefault();
    go(form.action + '?' + new URLSearchParams(new FormData(form)).toString(), true);
  });

  window.addEventListener('popstate', function (e) {
    if (e.state && e.state.lfShelf) go(window.location.href, false);
  });

  /* --- add to cart: eight states, one button --- */
  shelf.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-lf-add]')) return;
    e.preventDefault();
    var btn = form.querySelector('button');
    if (!btn || btn.getAttribute('aria-disabled') === 'true' || btn.classList.contains('is-busy')) return;
    var idle = btn.textContent;
    btn.classList.add('is-busy');
    btn.firstChild.nodeValue = 'Adding…';
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        btn.classList.remove('is-busy');
        btn.classList.add('is-done');
        btn.setAttribute('aria-disabled', 'true');
        btn.firstChild.nodeValue = btn.dataset.doneLabel || 'In your bag';
        var card = form.closest('[data-lf-card]'); if (card) card.classList.add('is-added');
        return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          document.querySelectorAll('.cart-count, [data-cart-count], .lf-head__cart-count').forEach(function (el) { el.textContent = cart.item_count; });
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: cart } }));
        }).catch(function () {});
      })
      .catch(function () {
        btn.classList.remove('is-busy');
        btn.classList.add('is-error');
        btn.firstChild.nodeValue = btn.dataset.errorLabel || "Didn't add — retry";
        setTimeout(function () { btn.classList.remove('is-error'); btn.firstChild.nodeValue = idle; }, 4000);
      });
  });
})();